<template>
  <div class="container shadowed">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ShadowContainer'
}
</script>
<style lang="scss" scoped>
  .container {
    &.shadowed {
      border-radius: 8px;
      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
      background-color: white;
      width: 100%;
      height: auto;
      min-height: 100px;
      padding: 40px;
    }
  }
</style>
